import { Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { Piece, Workflow } from '@apiContract';
import Footer from '@components/DrawerContent/Footer';
import Title from '@components/DrawerContent/Title';

import NotLockersContent from './components/NotLockers';
import { sxMain, sxP20, sxPaper } from './styles';
import { useLocationId } from './useLocationId';
import LockerContent from './components/Lockers';

type LocationIDProps = {
  piece: Piece;
  onChange: (data: Piece) => void;
  onClose: () => void;
  context?: 'capture';
};

const LocationID = ({ piece, onChange, onClose, context }: LocationIDProps) => {
  const [isLoadingContainerByReq, setIsLoading] = useState(false);

  const { pieceLocation, id, workflow } = piece;

  const {
    setSpot,
    spot,
    error,
    onSaveLocation,
    isLoading: updatePieceLoading,
  } = useLocationId(piece, id, onChange, onClose, context);

  return (
    <Paper elevation={3} sx={sxPaper}>
      <Title title="Location ID" onClose={onClose} />
      <Stack spacing={3} sx={sxMain}>
        <Typography variant="subtitle1">{pieceLocation?.container.containerTitleFormatted}</Typography>
        {workflow !== Workflow.Lockers && (
          <NotLockersContent
            piece={piece}
            setIsLoading={setIsLoading}
            isLoadingContainer={isLoadingContainerByReq}
            onChange={setSpot}
            spot={spot}
          />
        )}
        {workflow === Workflow.Lockers && (
          <LockerContent error={error} spot={spot} onChange={setSpot} />
        )}
      </Stack>
      <Footer
        sx={sxP20}
        isLoading={updatePieceLoading || isLoadingContainerByReq}
        handleSubmit={onSaveLocation} // itemType: PieceType, itemSpot?: string | number
        title="Save Changes"
      />
    </Paper>
  );
};

export default LocationID;
